import { useReportControlContext } from '~/modules/report-analytic/contexts';
import { useOrderParameters } from '~/modules/order-analytic/hooks';
import { useQueryOrderListing } from '~/modules/order-analytic/api';
import { EReportParamKeys } from '~/modules/report-analytic/types';
import { IRMetricKey } from '~/presentation/reports/common/type';
import { EAnalyticMode } from '~/modules/analytics/types';
import { useSearchParams } from '@remix-run/react';
import { useMemo } from 'react';

export const useReportOrderTotal = () => {
  const { metrics } = useReportControlContext();

  const [searchParams] = useSearchParams();
  const mode =
    (searchParams.get(EReportParamKeys.MODE) as EAnalyticMode) ?? EAnalyticMode.ALL_SESSION;

  const hasOrdersMetric = useMemo(() => metrics.includes(IRMetricKey.ORDERS), [metrics]);

  const { parameters: parametersForTotalOrders } = useOrderParameters({
    metrics: ['orders'],
    isQueryTotal: true,
    mode,
    isSyncSearchParams: false,
  });
  const { total: totalStoreOrders } = useQueryOrderListing({
    variables: parametersForTotalOrders,
    enabled: hasOrdersMetric,
    name: 'ReportOrderStoreTotalQL',
  });

  return {
    totalStoreOrders: hasOrdersMetric ? totalStoreOrders : undefined,
  };
};
